import { render, staticRenderFns } from "./ChatbotConfig.vue?vue&type=template&id=5cc179f3&lang=pug"
import script from "./ChatbotConfig.vue?vue&type=script&lang=js"
export * from "./ChatbotConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cc179f3')) {
      api.createRecord('5cc179f3', component.options)
    } else {
      api.reload('5cc179f3', component.options)
    }
    module.hot.accept("./ChatbotConfig.vue?vue&type=template&id=5cc179f3&lang=pug", function () {
      api.rerender('5cc179f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/config/ChatbotConfig.vue"
export default component.exports